import "./Form";

import ShowDuplicityModal from "./modals/ShowDuplicityModal.vue";

Vue.component('show-duplicity-modal', ShowDuplicityModal);



// WEBPACK FOOTER //
// ./resources/assets/admin/js/document-template/index.js